<template>
  <div class="metric-survey-rr">
    <div
      class="response-group"
      v-for="r in responseGroupsFiltered"
      :key="r"
    >
      {{nameForGroup(r)}}: {{responseRateForGroup(r)}} <span v-if="isSchoolDataLoaded">({{responseRecForGroup(r)}} surveys submitted)</span>
    </div>
    <LinkExternalUrl
      class="survey-recognition"
      v-if="isSurveyRecognitionSchool"
      :url="surveyRecognitionURL"
    >
      <img :src="icon" alt="survey ribbon icon" /><span>NYC School Survey Response Rate Award Recipient</span>
    </LinkExternalUrl>
    <LinkExternalUrl
      class="more-survey"
      :url="panoramaURL"
    >
      View responses to all of the NYC survey questions
    </LinkExternalUrl>
  </div>
</template>

<script>
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

import { NS_CURRENT_REPORT } from '../const'

import MetadataBase from './MetadataBase'
import LinkExternalUrl from '@/components/LinkExternalUrl'

const responseGroups = ['p', 't', 's'] // Display order

const responseGroupName = {
  't': 'Teachers',
  'p': 'Families',
  's': 'Students'
}
const responseGroupLookup = {
  't': 'teacher',
  'p': 'parent',
  's': 'student'
}

/* Valid Slot Names for this Component */
const SN_RR_BY_GROUP = {}
const SN_REC_BY_GROUP = {}
Object.keys(responseGroupLookup).map(d => {
  SN_RR_BY_GROUP[d] = responseGroupLookup[d] + '_rr'
  SN_REC_BY_GROUP[d] = responseGroupLookup[d] + '_rec'
})

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolHasPK',
      'panoramaURL',
      'isSurveyRecognitionSchool',
      'surveyRecognitionURL'
    ])
  },
  components: {
    LinkExternalUrl
  }
})
export default class MetricSurveyRR extends MetadataBase {
  icon = require('@/assets/img/survey_ribbon.svg')

  /* Getters */
  get responseGroupsFiltered () {
    return responseGroups.filter(r => this.hasSlotName(SN_RR_BY_GROUP[r]))
  }

  /* Methods - utility */
  nameForGroup (r) {
    let ret = responseGroupName[r]
    if (r === 'p' && this.selectedSchoolHasPK) {
      ret += ' (not including Pre-K)'
    }
    return ret
  }
  responseRateForGroup (r) {
    return this.dispValueForSlotName(SN_RR_BY_GROUP[r])
  }
  responseRecForGroup (r) {
    return this.dispValueForSlotName(SN_REC_BY_GROUP[r])
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../css/const.scss';
$link-top-margin: 12px;
$survey-recognition-color: #4A831B;
.response-group {
  display: block;
  padding-right: 24px;
  &:last-child {
    padding-right: 0px;
  }
  padding-left: $info-desc-indent;
  text-indent: -$info-desc-indent;
}
.more-survey {
  display: inline-block;
  margin-top: $link-top-margin;
  font-style: italic;
}
.survey-recognition {
  display: inline-block;
  margin-top: $link-top-margin;
  font-style: italic;
  text-decoration-color: $survey-recognition-color;

  /deep/ span {
    color: $survey-recognition-color;
  }

  img {
    height: 14px;
    padding-top: 1px;
    padding-right: 3px;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/MetricSurveyRR.vue